<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg' }" :title="title")
    b-container(fluid)
      b-row.search-form
        b-col
          .d-flex.align-items-center
            b-form-select.mr-2(v-model="tableData.pagination.search_key" :options="selectOptions.list" size="sm" style="width: 100px" @change="changeSearchSelect")
            b-form-input.mr-2(v-if="selectInput.type === 'keyword'" v-model="tableData.pagination.search_value" @keyup.enter="search" size="sm" style="width: 150px")
            b-form-select.mr-2(v-if="selectInput.type === 'select'" v-model="tableData.pagination.search_value" :options="selectInput.list" size="sm" style="width: 150px" @change="search")
            b-btn(size="sm" @click="search") {{$t('search')}}
      b-card.table-card
        b-table(
          ref="userTable"
          :fields="tableData.fields"
          :items="fetchList"
          :key="tableData.key"
          :current-page="tableData.pagination.current"
          :per-page="tableData.pagination.limit"
          :empty-text="$t('no-content')"
          sort-by="name"
          tbody-class="lmm-table-body"
          show-empty
          responsive
        )
          //- body
          template(v-slot:cell(user_type)="row")
            span {{ memberType(row.item.user_type) }}

          template(v-slot:cell(add)="row")
            b-btn(size="sm" @click="$emit('select', row.item)") {{$t('selection')}}
        
      //- pagination
      .pagination-wrap
        div
          b-form-select(
            size="sm"
            v-model="tableData.pagination.limit"
            :options="tableData.pagination.perOptions"
          )
        b-pagination(
          size="sm"
          v-model="tableData.pagination.current"
          :total-rows="tableData.pagination.total"
          :per-page="tableData.pagination.limit"
          class="my-0 float-right"
        )

      .modal-footer
        b-button(size="sm" variant="secondary" @click="visible = false" pill) {{$t('close')}}
</template>

<script>
import Dialogs from "@/components/mixins/dialog/index.vue"
import { ApprovalAPI } from "@/api"
import _ from "lodash"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Dialogs,
  },
  computed: {
    selectInput() {
      return _.find(this.selectOptions.list, { value: this.tableData.pagination.search_key })
    },
    memberType() {
      return (value) => {
        if (value === 1) {
          return this.$t('user')
        } else if (value === 2) {
          return this.$t('policy_manager')
        } else if (value === 3) {
          return this.$t('policy_manager')
        } else if (value === 6) {
          return this.$t('mid_manager')
        } else {
          return "-"
        }
      }
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        this.visible = newVal
        this.tableData.pagination.context = this.data.context
        this.tableData.pagination.search_key = "name"
        this.tableData.pagination.search_value = ""
      },
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
    // "tableData.pagination.limit"() {
    //   if (this.tableData.pagination.current === 1) {
    //     this.fetchList()
    //   } else {
    //     this.tableData.pagination.current = 1
    //   }
    // },
    // "tableData.pagination.current"() {
    //   this.fetchList()
    // },
  },
  data() {
    return {
      visible: false,
      selectOptions: {
        list: [
          { value: "name", text: this.$t('account-manage'), type: "keyword" },
          { value: "id", text: this.$t('ID'), type: "keyword" },
          { value: "part_name", text: this.$t("department"), type: "keyword" },
          {
            value: "user_type",
            text: this.$t("permission"),
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              { text: this.$t('policy_manager'), value: "3" },
              { text: this.$t('mid_manager'), value: "6" },
            ],
          },
        ],
      },
      allSelected: false,
      allChecked: [],
      tableData: {
        key: 0,
        fields: [
          { key: "user_type", label: this.$t("permission"), thStyle: { minWidth: "100px" } },
          { key: "name", label: this.$t('account-manage'), thStyle: { minWidth: "120px" } },
          { key: "id", label: this.$t("ID"), thStyle: { minWidth: "120px" } },
          { key: "part_name", label: this.$t("department"), thStyle: { minWidth: "100px" } },
          { key: "add", label: this.$t("add"), thClass: "text-center", tdClass: "text-center", thStyle: { minWidth: "70px" } },
        ],
        list: [],
        pagination: {
          by: "mgrid",
          limit: 10,
          offset: 0,
          order: "asc",

          search_key: "name",
          search_value: "",
          search_mode: "pagination",

          flag_servant: true,
          context: null,

          total: 1,
          current: 1,
          perOptions: [
            { value: 5, text: "5" },
            { value: 10, text: "10" },
            { value: 15, text: "15" },
          ],
        },
      },
    }
  },
  methods: {
    fetchList(ctx) {
      if (!ctx) return
      if (ctx.sortBy === "") return
      this.tableData.pagination.by = ctx.sortBy
      this.tableData.pagination.limit = ctx.perPage
      this.tableData.pagination.order = ctx.sortDesc ? "desc" : "asc"
      this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit

      return ApprovalAPI.approvalLine.get("", { params: this.tableData.pagination }).then(resp => {
        this.allSelected = false
        this.tableData.list = resp.data.objects
        this.tableData.pagination.total = resp.data.meta.total_count

        return resp.data.objects
      })
    },
    // fetchList(ctx) {
    //   if (!ctx) return
    //   this.tableData.pagination.current = ctx.currentPage
    //   this.tableData.pagination.limit = ctx.perPage
    //   this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit
    //   return Users.get("", { params: this.tableData.pagination })
    //     .then(res => {
    //       const { data } = res
    //       this.tableData.pagination.total = data.meta.total_count
    //       this.tableData.list = data.objects

    //       return this.tableData.list
    //     })
    //     .catch(err => {
    //       console.log(err)
    //     })
    // },
    changeSearchSelect(value) {
      const selected = _.find(this.selectOptions.list, { value })
      if (selected.type === "select") {
        this.tableData.pagination.search_value = selected.list[0].value
        this.search()
      } else {
        this.tableData.pagination.search_value = ""
      }
    },
    search() {
      this.tableData.pagination.current = 1
      this.tableData.key++
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .b-table {
  margin: 0;
  tr,
  th {
    padding: 0.5rem 0 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  td {
    padding: 0 0 0 1rem;
    color: #6f6f6f;
    font-weight: 400;
    height: 40px;
  }
}
</style>
